module.exports = __webpack_public_path__ + "media/images/logo-lavu-text-aacfa444815cabfa12642f1db431a9fa.svg";